import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { LucideIcon } from 'lucide-react';

interface SectionTitleProps {
  icon: LucideIcon;
  title: string;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ icon: Icon, title }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
      <Box
        sx={{
          backgroundColor: `${theme.palette.primary.main}15`,
          borderRadius: 1,
          p: 1,
          display: 'flex',
        }}
      >
        <Icon size={18} color={theme.palette.primary.main} />
      </Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
        {title}
      </Typography>
    </Box>
  );
};

export default SectionTitle;
